(() => {
  const pickerSelector = '[data-template*="product"] .variant-picker';
  const labelSelector = '.variant-option__button-label';

  function isSelected(input) {
    return Boolean(
      input?.checked ||
      input?.dataset?.currentChecked === 'true' ||
      input?.getAttribute('aria-checked') === 'true'
    );
  }

  function updatePicker(picker) {
    picker.querySelectorAll(labelSelector).forEach((label) => {
      const input = label.querySelector('input');
      if (!input) return;
      label.dataset.parseaSelected = isSelected(input) ? 'true' : 'false';
    });
  }

  function updateAll(root = document) {
    root.querySelectorAll?.(pickerSelector).forEach(updatePicker);
  }

  function scheduleUpdate(root = document) {
    window.requestAnimationFrame(() => updateAll(root));
  }

  document.addEventListener('DOMContentLoaded', () => {
    updateAll();

    const productArea = document.querySelector('[data-template*="product"]');
    if (!productArea) return;

    new MutationObserver(() => scheduleUpdate()).observe(productArea, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['checked', 'data-current-checked', 'aria-checked'],
    });
  });

  document.addEventListener('change', (event) => {
    if (event.target.matches?.(`${pickerSelector} input`)) scheduleUpdate();
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest?.(`${pickerSelector} ${labelSelector}`)) scheduleUpdate();
  });

  document.addEventListener('shopify:section:load', (event) => scheduleUpdate(event.target));
})();
